export { useControladorDeConteudos } from './controlador-de-conteudos.hook'
export * from './controlador-de-conteudos.config'
